import React, { useEffect, useState } from 'react';
import Modal from "../../../../components/molecules/Modal";
import { Input, TextArea, Select } from '../../../../components/input';
import { createTicket } from '../../../../store/action/ticket';


export default function NewTicketModal (props) { 
    const [ loading, setLoading ] = useState(false);
    const [ values, setValues ] = useState({
        description:"",
        title:"",
        type:"complaint",
        order_ids:"",
        reporter_contact_name:"",
        reporter_contact_phone:"",
        is_notify_to_phone:false,
        reference_id:""
    });
    

    const submitTicket = async () => {
        setLoading(true);
        const response = await createTicket(values);
        if (response.success) {
            alert(`Komplain berhasil terkirim. Tim kami akan segera menangani permasalahan Anda`)
            window.location.reload();
            return
        } else {
            alert(response.error);
        }
        setLoading(false);
    }

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            title={"Buat Tiket Baru"}
            buttons
            loading={loading}
            type={"oneButton"}
            bClick={submitTicket}
            bText={"Submit Tiket Baru"}
        >
            <Input
                label="Judul Tiket Anda"
                placeholder="Judul Tiket"
                onChange={e => setValues({...values,title:e.target.value})}
            />
            <Select
                label="Tipe komplain Anda"
                options={options}
                value={values.type}
                onChange={e => setValues({...values,type:e.target.value})}
            />
            <TextArea
                className="mt-4"
                label="Masukkan detail keluhan Anda disini"
                placeholder="Input informasi yang Biteship butuhkan untuk memudahkan penyelesaian masalah"
                onChange={e => setValues({...values,description:e.target.value})}
            />
            <TextArea
                className="mt-4"
                label="Masukkan list order Id atau atau resi yang bermasalah dipisah dengan koma (,)"
                placeholder="xxxx,yyyy,zzzz"
                onChange={e => setValues({...values,order_ids:e.target.value})}
            />

            <div className='form-row mt-4 '>
                <Input
                    className="col-6"
                    label="Nama orang pelapor"
                    placeholder="Yang bertanggung jawab"
                    onChange={e => setValues({...values,reporter_contact_name:e.target.value})}
                />
                <Input
                    className="col-6"
                    label="Nomor referensi Anda"
                    placeholder="Nomor referensi internal"
                    onChange={e => setValues({...values,reference_id:e.target.value})}
                />
            </div>
            <div className='form-row mt-4 '>
                <div className='col-6 mt-2 ' >
                    <div className='row ml-2'>
                        <div className="custom-control custom-switch " onClick={() => setValues({...values,is_notify_to_phone:!values.is_notify_to_phone})} >
                            <input
                                type="checkbox"
                                className="custom-control-input "
                                checked={values.is_notify_to_phone}
                                onClick={() => setValues({...values,is_notify_to_phone:!values.is_notify_to_phone})} 
                                />
                            <label className="custom-control-label"></label>
                        </div>
                        <span>Notifikasi ke HP</span>
                    </div>
                    
                </div>
                {
                    values.is_notify_to_phone ? 
                    <Input
                        className="col-6"
                        placeholder="Masukkan no Handphone Anda"
                        onChange={e => setValues({...values,reporter_contact_phone:e.target.value})}
                    />
                    :null
                }
                
            </div>
            
        </Modal>
    )
}

const options = [{
    label:`Komplain Pengiriman`,
    value:`complaint_shipment`
},{
    label:`WooCommerce`,
    value:`complaint_woocommerce`
},{
    label:`Komplain Dashboard`,
    value:`complaint_dashboard`
},{
    label:`Kendala COD`,
    value:`complaint_cod`
},{
    label:`Klaim Pengiriman`,
    value:`claim`
},{
    label:`Status Pengiriman`,
    value:`shipping_status`
},{
    label:`Pembayaran`,
    value:`payment`
},{
    label:`Fitur Produk`,
    value:`product_feature`
},{
    label:`Error Layanan`,
    value:`service_error`
}]